import React, { useEffect,  useState, } from 'react';
import axios from 'axios';
//import './User_Creation.css';
import { BASE_URL } from "../../constants";
import { Button, Container, OverlayTrigger, Tooltip, Card, Row, Col, Form, InputGroup } from 'react-bootstrap';
//import deleteIcon from './image/delete.png';
import "bootstrap/dist/css/bootstrap.min.css";
import "../../CommonCSS/SocietyCSS.css";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import SearchUserModal from './SearchUserModal';

function User_Creation() {

    const [loginId, setLoginId] = useState();
    const [editMode, setEditMode] = useState('N');
    const [userName, setUserName] = useState();
//    const [roleId, setRoleId] = useState();
    const [password, setPassword] = useState('');
    const [confrimPwd, setConfrimPwd] = useState();
    const [addMode, setAddMode] = useState(true);
    const [designation, setDesignation] = useState();
    const [userType, setUserType] = useState('Normal');
 //   const [showEditPopup, setShowEditPopup] = useState(false);
    const [errors, setErrors] = useState({});
//    const [showPopup, setShowPopup] = useState(false);
    const [roles, setRoles] = useState([]);
    const [userId, setUserId] = useState(); //changed
    const [statusOptions, setStatusOptions] = useState([]);
    const [status, setStatus] = useState('');
    const [showsearchModal, setShowSearchModal] = useState(false);

    const [details, setDetails] = useState([{ role_id: '', user_id: '' }]); 

    // useEffect(() => {
    //     const allOptions = {
    //         A: "Active",
    //         I: "Inactive",
    //         H: "Hold",
    //         R: "Resigned"
    //     };

    // }, []);

    const handleStatusChange = (e) => {
        setStatus(e.target.value); // Only update the local state here
    };

    useEffect(() => {
        axios.get(`${BASE_URL}/api/get_all_roles`)
            .then(response => { setRoles(response.data) })
            .catch(error => console.error('Error Fetching Roles', error));
    }, []);

    const handleSave = async () => {

        for (let i = 0; i < details.length; i++) {

            if (!details[i].role_id) {
                toast.error(`Please select Role at Row # ${i + 1}`);
                return;
            }

        }

        const uniqueRoleIds = new Set();

        for (let i = 0; i < details.length; i++) {

            if (uniqueRoleIds.has(details[i].role_id)) {
                toast.error(`Duplicate Role Id at row ${i + 1}`);
                return;
            }

            uniqueRoleIds.add(details[i].emp_id);

        }

        const mainData = {
            loginId,
            userName,
            password,
            designation,
            userType,
            editMode,
            p_user_id: userId, //changed
            status,
        };

        const data = {
            header: mainData,
            details: details
        };

        const isConfirmed = window.confirm("Sure you want to update the record?");

        if (!isConfirmed) {
            return;
        }

        try {
            // Save user data
            const saveResponse = await axios.post(`${BASE_URL}/api/update_user_roles`, data);

            if (saveResponse.status === 200) {
                toast.success('User updated successfully!');
            }
            // Clear form state
            clear();

        } catch (error) {
            // Handle errors
            console.error('Error saving user:', error);
            toast.error(error.response.data.message || 'Error updating user.');
        }
    };

    // const handleSave = async () => {

    //     const strongPasswordRegex = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[\W_]).{6,}$/;
    //     const loginLength = /^.{6,}$/;

    //     if (!loginId || !loginLength.test(loginId)) {
    //         alert('Login Id must be at least 6 characters long.');
    //         return;
    //     }
    //     if (!userName) {
    //         alert('Please Enter User Name.');
    //         return;
    //     }
    //     if (editMode === 'N') {
    //         if (!password) {
    //             alert('Please Enter Password.');
    //             return;
    //         }
    //         if (!confrimPwd) {
    //             alert('Please Enter Confirm Password.');
    //             return;
    //         }
    //     }
    //     if (password) {
    //         if (!strongPasswordRegex.test(password)) {
    //             alert('Password must be at least 6 characters long and include uppercase, lowercase, number and special character.');
    //             return;
    //         }
    //     }

    //     if (password && confrimPwd) {
    //         if (password !== confrimPwd) {
    //             alert('Passwords do not match. Please try again');
    //             return;
    //         }
    //     }

    //     for (let i = 0; i < details.length; i++) {

    //         if (!details[i].role) {
    //             alert(`Please select Role at Row # ${i + 1}`);
    //             return;
    //         }

    //     }

    //     const uniqueRoleIds = new Set();

    //     for (let i = 0; i < details.length; i++) {

    //         if (uniqueRoleIds.has(details[i].role)) {
    //             alert(`Duplicate Role Id at row ${i + 1}`);
    //             return;
    //         }

    //         uniqueRoleIds.add(details[i].emp_id);

    //     }

    //     const mainData = {
    //         loginId,
    //         userName,
    //         password,
    //         designation,
    //         userType,
    //         editMode,
    //         userId, //changed
    //         status,
    //     };

    //     const data = {
    //         header: mainData,
    //         details : details
    //     };

    //     const isConfirmed = window.confirm("Sure you want to save the record?");
    //     if (!isConfirmed) {
    //         return;
    //     }
    //     try {
    //         // Save user data
    //         const saveResponse = await axios.post(`${BASE_URL}/api/save_user`, data);
    //         console.log('UserType:', data.header.userType);

    //         if (saveResponse.status === 200) {
    //             alert('User saved successfully!');
    //             // Update status only if save was successful
    //             await updateStatus();
    //         }

    //         // Clear form state
    //         clear();

    //     } catch (error) {
    //         // Handle errors
    //         console.error('Error saving user:', error);
    //         if (error.response) {
    //             alert(error.response.data.message || 'Error creating user.');
    //         } else {
    //             alert('User creation failed.');
    //         }
    //     }
    // };

    const handleAddRole = () => {
        setAddMode(false);
        setEditMode('N');
    }


    const clear = () => {
        setLoginId('');
        setEditMode('N');
        setUserName('');
        setPassword('');
        setConfrimPwd('');
        setAddMode(true);
        setDesignation('');
        setUserType('Normal');
        setDetails([{ role_id: '', user_id: '' }]);//changed
        // setRoles([]);
        setUserId('');   //changed
        setStatus([]);
    }

    const handleClearUser = async () => {

        const isConfirmed = window.confirm('Sure, do you want to clear?');
        if (!isConfirmed) {
            return;
        }

        clear();
    }

    const handleAddRow = () => {
        setDetails([...details, { role_id: '', user_id: '' }]) //changed
    }
    const handleDeleteRow = (index) => {
        // if (details[index]?.user_id) { //changed
        //     alert('Previously saved role for this user can not be deleted.');
        //     return;
        // }
        const deletedRow = details[index];
        const temp = details.filter((_, i) => i !== index);
        setDetails(temp);
    }


    const handleInputChange = (index, field, value) => {

        const newDetails = [...details];

        newDetails[index][field] = value;

        setDetails(newDetails);
    }

    const handleRowSelect = async (selRow) => {

        try {

            setShowSearchModal(false);

            const response = await axios.get(`${BASE_URL}/api/get_user_byUserId`, {
                params: { p_user_id: selRow.user_id },
            });

            const employee = response.data.userDetails || {};
            const roles = response.data.roleDetails || {};

            setUserName(employee.user_name);
            setLoginId(employee.login_id);
            setUserId(employee.user_id);
            setStatus(employee.user_status);

             setDetails(roles);
    
            setAddMode(false);
            setEditMode('Y');

            // setIsEditable(true);

        } catch (err) {
            console.error(err);
        }

    };

    // const handleVoucharRowSelect = async (master_data) => {

    //     console.log('master_data ', master_data);
    //     setUserName(master_data[0].user_name);
    //     setLoginId(master_data[0].login_id);
    //     setDesignation(master_data[0].designation);
    //     setUserType(master_data[0].user_type);
    //     setUserId(master_data[0].user_id);
    //     setStatus(master_data[0].user_status);

    //     const newDetails = master_data.map(details => ({
    //         role: details.role_id,
    //         valid_till: details.valid_till,
    //         user_id: details.user_id //Changed
    //     }));
    //     setDetails(newDetails);

    //     setAddMode(false);
    //     setEditMode('Y');
    //     setShowEditPopup(false);

    // }

    return (

        <Container fluid className="p-3">

            <Card className="p-4 shadow-sm">

                <Row className="mb-3">

                    <Col md={6}>
                        <InputGroup>
                            <InputGroup.Text style={{width: '200px', backgroundColor: 'lightblue'}}>Login Id </InputGroup.Text>
                            <Form.Control type="text" name="loginId" value={loginId}
                                disabled={editMode === 'Y' ? true : addMode} onChange={(e) => { setLoginId(e.target.value) }} />
                        </InputGroup>
                    </Col>

                    <Col md={6}>
                        <InputGroup>
                            <InputGroup.Text style={{width: '200px', backgroundColor: 'lightblue'}}>User Name </InputGroup.Text>
                            <Form.Control type="text" name="userName" value={userName}
                                disabled={editMode === 'Y' ? true : addMode} onChange={(e) => { setUserName(e.target.value) }} />
                        </InputGroup>
                    </Col>

                </Row>

                {/* <Row className="mb-3">

                    <Col md={6}>
                        <InputGroup>
                            <InputGroup.Text style={{width: '200px', backgroundColor: 'lightblue'}}>Password </InputGroup.Text>
                            <Form.Control type="password" name="password" value={password}
                                disabled={editMode === 'Y' ? true : addMode} onChange={(e) => { setPassword(e.target.value) }} />
                        </InputGroup>
                    </Col>

                    <Col md={6}>
                        <InputGroup>
                            <InputGroup.Text 
                              style={{width: '200px', backgroundColor: 'lightblue'}}>
                                Confirm Password </InputGroup.Text>
                            <Form.Control type="password" name="confrimPwd" value={confrimPwd}
                                disabled={editMode === 'Y' ? true : addMode} onChange={(e) => { setConfrimPwd(e.target.value) }}/>
                        </InputGroup>
                    </Col>

                </Row> */}

                <Row className="mb-3">

                    <Col md={6}>
                        <InputGroup>
                            <InputGroup.Text style={{ width: '200px', backgroundColor: 'lightblue' }}>Status </InputGroup.Text>
                            <Form.Select name="status" value={status} 
                                     onChange={handleStatusChange} disabled={addMode} >
                                 <option value="">Select Status</option>
                                 <option value="A">Active</option>
                                 <option value="I">Inactive</option>
                                 <option value="H">Hold</option>
                                 <option value="R">Resigned</option>
                                 {/* {statusOptions.map((opt) => (
                                     <option key={opt.value} value={opt.value}>
                                         {opt.label}
                                     </option>
                                 ))} */}
                            </Form.Select>
                        </InputGroup>
                    </Col>

                    <Col md={6}>

                        <div className="col-md-12 mb-3 d-flex justiy-content-end" style={{ float: 'right', justifyContent: 'right' }}>

                            <button className="btn btn-primary me-2" style={{ width: '135px' }}
                               onClick={(e) => (setShowSearchModal(true))}
                                disabled={!addMode} > Search</button>

                            {showsearchModal && (
                                <SearchUserModal
                                    show={showsearchModal}
                                    handleClose={() => setShowSearchModal(false)}
                                    onRowSelect={handleRowSelect}
                                />
                            )}

                            <button className="btn  btn-secondary me-2" onClick={handleClearUser} style={{ width: '135px' }}
                                disabled={addMode}>Clear</button>

                            <button className="btn btn-success me-2" style={{ width: '135px' }} onClick={handleSave}
                                disabled={addMode}>Save</button>

                        </div>
                    </Col>

                </Row>

            </Card>

            <Card className="p-3">

                {/* <div className="table-wrapper"> */}
                 <div style={{ minHeight: '220px' }} className="table-wrapper">

                    <table style={{ maxHeight: '35px' }} className="responsive-table scty-custom-table">

                        <thead>
                            <tr>
                                <th style={{ width: "5%", textAlign: "center" }}>#</th>
                                <th style={{ width: "50%" }}>Role Name</th>
                                {/* <th style={{ width: "12%" }}>Valid Till</th> */}
                                <th style={{ width: "10%" }}></th>
                            </tr>
                        </thead>

                        <tbody>

                            {details.map((row, index) => (

                                <tr key={index}>

                                    <td style={{ textAlign: "center" }}>{index + 1}</td>

                                    <td>
                                        <select
                                             className="form-select"
                                            name="role"
                                            value={row.role_id}
                                            disabled={details[index]?.user_id ? true : false}
                                            onChange={e => handleInputChange(index, 'role_id', e.target.value)}>
                                                <option value="">-- Select Role --</option>
                                            {roles.map((role) => (
                                                <option key={role.role_id} value={role.role_id}>{role.role_name}</option>
                                            ))}
                                        </select>
                                    </td>

                                    <td style={{ textAlign: "center" }}>
                                        {details.length > 1 && (
                                            <Button
                                                variant="danger"
                                                size="sm"
                                                onClick={() => handleDeleteRow(index)}>Delete
                                            </Button>
                                        )}
                                    </td>

                                </tr>

                            ))}

                        </tbody>

                    </table>

                </div>

                <div className="d-flex justify-content-end mt-2">
                    <OverlayTrigger placement="bottom"
                        overlay={<Tooltip id="add-tooltip" style={{ backgroundColor: "#e9ecef" }}>Add Row</Tooltip>}>
                        <Button variant="primary"
                            onClick={handleAddRow}
                            //disabled={!isDetailsEnabled}
                            style={{
                                width: "45px",
                                height: "45px",
                                borderRadius: "50%",
                                padding: "0",
                                fontSize: "30px"
                            }}
                        >
                            +
                        </Button>
                    </OverlayTrigger>
                </div>

            </Card>

        </Container>

    );


}

export default User_Creation;
